import {useAuthStore} from "@/stores/Auth";

export async function refreshOrLogin(): Promise<boolean> {
    const authStore = useAuthStore();
    await authStore.refreshOrLogin();
    if (!authStore.accessToken) {
        console.error('User not authenticated - login required');
        return true;
    }
    return false;
}

